import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContentModal } from '@Components';
import { Button } from '@Components/common';

import styles from './ContactModal.module.scss';
import { RiFileCopyLine, RiMailLine } from 'react-icons/ri';

interface ContactModalProps {
  isOpen: boolean;
  onClose: (event: object, reason: string) => void;
  email: string;
}

export const ContactModal = ({ isOpen, onClose, email }: ContactModalProps) => {
  const { t } = useTranslation('profilePage');

  return (
    <ContentModal isOpen={isOpen} onClose={onClose} title={t('contact_modal.title')}>
      <div className={styles.content}>
        <p>{t('contact_modal.email_label', { email })}</p>
        <div className={styles.actions}>
          <Button
            buttonType="secondary"
            startIcon={<RiFileCopyLine />}
            onClick={() => navigator.clipboard.writeText(email)}
            className={styles.mailButton}
            size="small"
          >
            {t('contact_modal.copy_email')}
          </Button>

          <Button
            buttonType="secondary"
            startIcon={<RiMailLine />}
            href={`mailto:${email}`}
            className={styles.mailButton}
            size="small"
          >
            {t('contact_modal.send_email')}
          </Button>
        </div>
      </div>
    </ContentModal>
  );
};
